/**
 * DIEUKYDIEU.TV - APPLE SEGMENTED FILTER CHIP FACTORY (js/components/chip.component.js)
 * Standardized Apple Segmented Filter Pills & Sub-chips (< 150 lines).
 */

/**
 * Render chuỗi HTML cho Segmented Chip (Dùng chung cho Khám phá, Media, v.v.)
 * @param {Object} props - Tham số cấu hình chip
 * @returns {string} HTML string
 */
export function renderChipHTML(props = {}) {
    const {
        id = '',
        label = '',
        icon = '',
        isActive = false,
        hasSubmenu = false,
        variant = 'pill', // 'pill' | 'subchip'
        onClickAttr = '',
        staggerIndex = 0,
        legacyClass = '',
        extraAttrs = ''
    } = props;

    const baseClass = (variant === 'subchip') 
        ? 'cat-chip sub-chip apple-subchip' 
        : 'cat-chip apple-chip';
    const activeClass = isActive ? 'active' : '';
    const clickAttr = onClickAttr ? ` onclick="${onClickAttr}"` : '';
    const extra = extraAttrs ? ` ${extraAttrs}` : '';

    const iconHtml = icon ? `<span class="material-symbols-rounded chip-icon">${icon}</span>` : '';
    const chevronHtml = hasSubmenu ? `<span class="material-symbols-rounded chip-chevron">keyboard_arrow_down</span>` : '';

    return `
        <button class="${baseClass} ${activeClass} ${legacyClass}" 
                data-id="${id}"
                type="button" 
                role="tab" 
                aria-selected="${isActive ? 'true' : 'false'}"
                ${clickAttr}${extra}
                style="--stagger-index: ${staggerIndex};">
            ${iconHtml}
            <span>${label}</span>
            ${chevronHtml}
        </button>
    `.trim();
}

/**
 * Tạo trực tiếp HTMLElement cho Chip
 */
export function createChipElement(props = {}) {
    const temp = document.createElement('div');
    temp.innerHTML = renderChipHTML(props);
    const chipEl = temp.firstElementChild;

    if (typeof props.onClick === 'function') {
        chipEl.addEventListener('click', (e) => props.onClick(props.id, chipEl, e));
    }

    return chipEl;
}

/**
 * Utility hàm dùng chung để điều khiển kích hoạt Chip:
 * Gỡ bỏ active cũ và kích hoạt chip mới một cách chính xác
 * @param {HTMLElement|string} container - Container chứa danh sách chip hoặc id container
 * @param {string|HTMLElement} targetChipOrId - Chip cần active (element hoặc id)
 * @param {string} selector - Selector tìm kiếm chip (mặc định: '.cat-chip')
 */
export function setActiveChip(container, targetChipOrId, selector = '.cat-chip') {
    const root = typeof container === 'string' ? document.getElementById(container) : container;
    if (!root) return;

    root.querySelectorAll(selector).forEach(c => {
        c.classList.remove('active');
        c.setAttribute('aria-selected', 'false');
    });

    let activeEl = null;
    if (typeof targetChipOrId === 'string') {
        activeEl = root.querySelector(`[data-id="${targetChipOrId}"]`) ||
                   root.querySelector(`[data-child-id="${targetChipOrId}"]`);
    } else if (targetChipOrId instanceof HTMLElement) {
        activeEl = targetChipOrId;
    }

    if (activeEl) {
        activeEl.classList.add('active');
        activeEl.setAttribute('aria-selected', 'true');
        activeEl.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }
}
